/**
 * Entorno del front: se lee de import.meta.env (Vite, .env.sandbox / .env.prod de la raíz) y se
 * VALIDA al arrancar. Si falta algo o VITE_ENV no es sandbox/prod, la app no arranca.
 */
import { z } from 'zod';

const EnvSchema = z.object({
  VITE_ENV: z.enum(['sandbox', 'prod']),
  VITE_FIREBASE_PROJECT_ID: z.enum(['nuvvu-sandbox', 'nuvvu-efc61']),
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_FIREBASE_MEASUREMENT_ID: z.string().optional(),
  VITE_FIREBASE_DATABASE_ID: z.literal('nuvvu'),
  VITE_FIREBASE_REGION: z.literal('europe-west1'),
  VITE_FUNCTIONS_BASE_URL: z.string().url(),
  VITE_WEB_ORIGIN: z.string().url(),
  VITE_ADMIN_ORIGIN: z.string().url(),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
  /** Modo prueba real del sandbox (21/10): permite la clave live con cuentas internas (LIVE_TEST_UIDS en functions). */
  VITE_LIVE_TEST: z.enum(['0', '1']).optional(),
});
export type AppEnv = z.infer<typeof EnvSchema>;

function load(): AppEnv {
  const parsed = EnvSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    throw new Error(
      `Entorno del front no válido: ${JSON.stringify(parsed.error.flatten().fieldErrors)}`,
    );
  }
  const e = parsed.data;
  // Cruce de seguridad: sandbox con proyecto de prod (o al revés) no arranca.
  if ((e.VITE_ENV === 'sandbox') !== (e.VITE_FIREBASE_PROJECT_ID === 'nuvvu-sandbox')) {
    throw new Error(
      `VITE_ENV=${e.VITE_ENV} no coincide con VITE_FIREBASE_PROJECT_ID=${e.VITE_FIREBASE_PROJECT_ID}`,
    );
  }
  if (
    e.VITE_ENV === 'sandbox' &&
    e.VITE_STRIPE_PUBLISHABLE_KEY.startsWith('pk_live_') &&
    e.VITE_LIVE_TEST !== '1'
  ) {
    throw new Error('Clave pública LIVE de Stripe en sandbox');
  }
  return e;
}

export const env: AppEnv = load();
export const isSandbox = env.VITE_ENV === 'sandbox';
